import './Checkbox.css';

import type { FunctionComponent } from 'react';

import { Check } from '../Icons';

const CHECKBOX_CHECK_SIZE = 20;

export interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (newValue: boolean) => void;
}

export const Checkbox: FunctionComponent<CheckboxProps> = ({
  label,
  checked,
  onChange,
}) => {
  const onClick = () => {
    onChange(!checked);
  };

  return (
    <div className="checkbox-container">
      <div
        className={`checkbox checkbox-${checked ? '' : 'un'}checked`}
        onClick={onClick}
      >
        {checked && <Check size={CHECKBOX_CHECK_SIZE} />}
      </div>
      <label className="text-sm semibold checkbox-label" onClick={onClick}>
        {label}
      </label>
    </div>
  );
};
